import React, { useState } from 'react';
import { useLassoTool } from '../../application/lassoToolStore';
import { PlusIcon as Plus, MinusIcon as Minus } from '@heroicons/react/24/outline';
import { HandDraw as Hand, Layers } from '../../../../components/icons/OurIcons';
import { SATELLITE_VIEW_STYLE, STREET_VIEW_STYLE } from '../../../../utility/constants';
import { useMapStore } from '../../application/mapStore';

export const MapOverlayTools = ({ mapNode }: { mapNode: mapboxgl.Map }) => {
  const { isEnabled, toggle } = useLassoTool();
  const { isSatelliteView, setIsSatelliteView } = useMapStore();
  const [ isOptionsOpen, setIsOptionsOpen ] = useState(false);

  const mapToolBtn = 'w-10 h-10 flex flex-col items-center justify-center bg-white border rounded shadow hover:bg-gray-100 text-gray-800';

  const zoomIn = () => mapNode.zoomIn();
  const zoomOut = () => mapNode.zoomOut();

  const changeMapView = (isSatellite: boolean) => {
    if (!mapNode) {
      return;
    }
    const newStyle = isSatellite ? SATELLITE_VIEW_STYLE : STREET_VIEW_STYLE;
    mapNode.once('style.load', () => {
      setIsSatelliteView(isSatellite);
    });
    mapNode.setStyle(newStyle);
    setIsOptionsOpen(false);
    setTimeout(() => {
      // If style is toggled too fast, then it sometimes throws an error
      console.log('changeMapView from MapOverlayTools ', isSatellite);
    }, 1000);
  };

  const viewTypes = [
    { id: 'street', name: 'Street View', isSatellite: false },
    { id: 'satellite', name: 'Satellite View', isSatellite: true },
  ];

  return (
    <div className="absolute top-4 right-4 z-1 flex flex-col gap-2 p-2 pointer-events-auto">
      {/* Zoom In Button */}
      <button id="zoom-in-button" className={mapToolBtn} onClick={zoomIn}>
        <Plus  className="w-5 h-5" />
      </button>
      {/* Zoom Out Button */}
      <button id="zoom-out-button" className={mapToolBtn} onClick={zoomOut}>
        <Minus className="w-5 h-5" />
      </button>
      {/* Lasso Draw Button */}
      <button
        id="lasso-draw-button"
        className={`${mapToolBtn} ${isEnabled ? '!border-4 !border-indigo-400' : ''}`}
        onClick={toggle}
        title="Lasso Draw"
      >
        <Hand size={24} />
        <span className="text-xs">Draw</span>
      </button>
      {/* Map View Options */}
      <div className="relative">
        <button
          id="layers-button"
          className={`${mapToolBtn}`}
          onClick={() => setIsOptionsOpen(!isOptionsOpen)}
        >
          <Layers size={24} />
        </button>

        {/* Custom Options Panel */}
        <div
          id="map-view-options-panel"
          className={`absolute right-full top-0 mr-2 p-1 flex gap-1 
            backdrop-blur-xl bg-white/30 
            rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.15)]
            border border-white/40 
            transition-all duration-300 ease-out z-50
            ${ isOptionsOpen ? 'opacity-100 translate-x-0 pointer-events-auto' : 'opacity-0 translate-x-2 pointer-events-none' }
    }`}
        >
          {viewTypes.map((viewType) => (
            <button
              key={viewType.id}
              onClick={() => changeMapView(viewType.isSatellite)}
              className={`px-5 py-2.5 text-sm  rounded-lg transition-all duration-200 whitespace-wrap  ${
                isSatelliteView === viewType.isSatellite
                  ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-600/30'
                  : 'text-gray-700 hover:bg-white/80 hover:shadow-md'
              }`}
            >
              {viewType.name}
            </button>
          ))}
        </div>
      </div>
      {/* <button id="map-view-button" className={`${mapToolBtn} opacity-50`} disabled>
        <Globe className="w-5 h-5" />
        <span className="text-xs">Map</span>
      </button> */}
    </div>
  );
};
